import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import HyperDX from '@hyperdx/browser';

import { AppModule } from './app/app.module';

// Detecta se o navegador é Safari (qualquer versão)
function isSafari(): boolean {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// Retorna a versão major do Safari, ou null se não for Safari
function getSafariMajorVersion(): number | null {
  if (!isSafari()) return null;
  const userAgent = navigator.userAgent;
  // Mac Safari: "Version/16.6 Safari/..."
  const versionMatch = userAgent.match(/Version\/(\d+)\.(\d+)/);
  if (versionMatch && versionMatch.length >= 2) {
    return parseInt(versionMatch[1], 10);
  }
  // iOS Safari: "OS 16_0 like Mac OS X"
  const iosMatch = userAgent.match(/OS (\d+)_(\d+)/);
  if (iosMatch && iosMatch.length >= 2) {
    return parseInt(iosMatch[1], 10);
  }
  return null;
}

// Safari <= 16 tem bugs com FetchEvent.respondWith() e CacheStorage
const safariVersion = getSafariMajorVersion();
const isProblematicSafari = safariVersion !== null && safariVersion <= 16;

// Desabilita advancedNetworkCapture no Safari para evitar conflito
// entre monkey-patching do fetch/XHR e o Service Worker

// --- HyperDX resiliente: só inicializa se o endpoint estiver acessível ---
const HYPERDX_CHECK_URL = 'https://in-otel.hyperdx.io/v1/traces';
const HYPERDX_CHECK_INTERVAL = 60_000; // re-check a cada 60s se falhou
let hyperdxInitialized = false;

function initHyperDX(): void {
  if (hyperdxInitialized) return;
  try {
    HyperDX.init({
      apiKey: '0550a0e8-9cbd-459d-88a9-d76902e15aa9',
      service: 'westh-frontend',
      tracePropagationTargets: [/server.westetics.com.br/i],
      consoleCapture: true,
      advancedNetworkCapture: !isProblematicSafari,
    });
    hyperdxInitialized = true;
    console.log('[HyperDX] Inicializado com sucesso.');
  } catch (e) {
    console.warn('[HyperDX] Falha ao inicializar:', e);
  }
}

function checkAndInitHyperDX(): void {
  if (hyperdxInitialized) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5_000);
  fetch(HYPERDX_CHECK_URL, { method: 'HEAD', mode: 'no-cors', signal: controller.signal })
    .then(() => {
      clearTimeout(timeout);
      initHyperDX();
    })
    .catch(() => {
      clearTimeout(timeout);
      console.warn('[HyperDX] Endpoint inacessível. Telemetria desativada. Re-tentando em 60s...');
      setTimeout(checkAndInitHyperDX, HYPERDX_CHECK_INTERVAL);
    });
}

checkAndInitHyperDX();

// Desativa Service Worker em Safari <= 16 (bugs com FetchEvent e CacheStorage)
if (isProblematicSafari && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// A inicialização do Angular AppModule não depende mais do environment.production para ser chamada,
// mas o environment ainda pode ser usado internamente pelo Angular ou outras partes do código.
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
